// @ts-ignore
import { ZFSUploaderCabinet } from '@zto/tuxi-operate-web-base'
// @ts-ignore
import type { App } from '@zto/zpage'

/**
 * 富文本编辑器专用上传函数
 * 使用 ZFSUploaderCabinet 进行文件上传
 */
export const uploadForEditor = async (file: File, app: App, options?: {
  storePath?: string
  storeGroup?: string
  uploadType?: string
}): Promise<string> => {
  try {
    const uploadOptions = {
      app,
      storePath: options?.storePath || 'tmp/',
      storeGroup: options?.storeGroup || 'public',
      uploadType: options?.uploadType || 'twt_upload', // 使用通用的上传类型
      onProgress: (progress: any) => {
        // 可以在这里处理上传进度，如果需要的话
        console.log('Upload progress:', progress)
      },
      onUpload: (uploadInfo: any) => {
        // 可以在这里处理上传信息，如果需要的话
        console.log('Upload info:', uploadInfo)
      }
    }

    const result = await ZFSUploaderCabinet.upload(file, uploadOptions)
    
    // 返回上传结果中的文件URL
    if (result && result.result && result.result.url) {
      return result.result.url
    } else {
      throw new Error('上传响应格式异常')
    }
  } catch (error) {
    console.error('富文本编辑器上传文件失败:', error)
    throw error
  }
}